export const AdminHome = () => {
    return (
        <h1>Administration</h1>
    )
}